import classNames from 'classnames';

import styles from './Loader.module.scss';

export function Loader(props: {
  /**
   * @deprecated For actual fullscreen behaviour, use `fullScreen` (camel-cased).
   * For the same old parent-filling behaviour, use `fillContent`.
   */
  fullscreen?: boolean;
  fullScreen?: boolean;
  fillContent?: boolean;
  cover?: boolean;
  customClassName?: string;
}) {
  const className = classNames(
    {
      [styles.cover]: props.cover,
      [styles.fillContent]: props.fillContent || props.fullscreen,
      [styles.fullScreen]: props.fullScreen,
    },
    props.cover ? props.customClassName : (props.customClassName ?? styles.loaderWrapper),
  );

  return (
    <div className={className}>
      <div className={styles.loader}>
        <div className="loader-social-cc">
          <svg viewBox="0 0 484 243" xmlns="http://www.w3.org/2000/svg">
            <circle className="loader-white" cx="121" cy="121" r="121" />
            <path
              className="loader-social"
              d="M56.58 120.93a60.77 60.77 0 0 1 4.92-25.79 57.2 57.2 0 0 1 14.16-19.62 62.15 62.15 0 0 1 21.39-12.39A76.92 76.92 0 0 1 123.48 59a84.23 84.23 0 0 1 27.35 4.81 72.14 72.14 0 0 1 15 7.28 7.05 7.05 0 0 1 1.83 10.59l-15.47 17.89a7.62 7.62 0 0 1-10 1.21 23.81 23.81 0 0 0-3.94-2.18 29.84 29.84 0 0 0-11.82-2.42 26.91 26.91 0 0 0-9.84 1.63 22.35 22.35 0 0 0-7.94 5 22.77 22.77 0 0 0-5.26 8.08 27.82 27.82 0 0 0-1.78 10.64 26.26 26.26 0 0 0 2.17 10.52 25.72 25.72 0 0 0 5.57 8 24 24 0 0 0 8.08 5.23 27.12 27.12 0 0 0 9.71 1.9 25 25 0 0 0 12.37-2.69 29 29 0 0 0 3.18-2A7.83 7.83 0 0 1 153 144l16 18.22a6.84 6.84 0 0 1-1 10.19 63.66 63.66 0 0 1-14.85 7.81q-12.26 4.62-27.92 4.41a77.38 77.38 0 0 1-26.56-4.89 66.93 66.93 0 0 1-21.74-13.13 62.8 62.8 0 0 1-14.71-20 61.57 61.57 0 0 1-5.64-25.67Z"
            />
          </svg>
        </div>
        <div className="loader-social-sc">
          <svg viewBox="0 0 484 243" xmlns="http://www.w3.org/2000/svg">
            <circle className="loader-white" cx="363" cy="121" r="121" />
            <path
              className="loader-sweep"
              d="M362 184.81a78.76 78.76 0 0 1-13.86-1.22 74.37 74.37 0 0 1-13.07-3.59 80.93 80.93 0 0 1-11.89-5.54c-1.28-.73-2.51-1.49-3.71-2.28a6.79 6.79 0 0 1-1.28-10.27l14.3-15.53a6.73 6.73 0 0 1 8.93-.9 44.9 44.9 0 0 0 6.44 3.92 30.78 30.78 0 0 0 14 3.44 15.3 15.3 0 0 0 6-1.15 4.26 4.26 0 0 0 2.71-4.27 4.47 4.47 0 0 0-.91-2.79 10.24 10.24 0 0 0-3.19-2.38 49.07 49.07 0 0 0-6.31-2.71c-2.67-1-6.05-2.14-10.09-3.45a86.94 86.94 0 0 1-11.31-4.68 39.83 39.83 0 0 1-9.59-6.66 28.88 28.88 0 0 1-6.64-9.44 32.1 32.1 0 0 1-2.46-13.22q0-10.84 4.43-18.4a38.87 38.87 0 0 1 11.4-12.4 46.58 46.58 0 0 1 15.66-7 71.58 71.58 0 0 1 17.21-2.14 67 67 0 0 1 23.37 4.42 63.47 63.47 0 0 1 14.92 7.9 6.74 6.74 0 0 1 .81 10.18l-14.35 14.67a6.73 6.73 0 0 1-9 .61 28.66 28.66 0 0 0-15.77-5.79 16.17 16.17 0 0 0-6.88 1.23 4.3 4.3 0 0 0 .08 7.95 78.25 78.25 0 0 0 8.78 3.28q6.23 2 13.11 4.59a56 56 0 0 1 12.75 6.81 36 36 0 0 1 9.59 10.24q3.76 6.07 3.77 15.09a38.08 38.08 0 0 1-4.18 18.29 39.64 39.64 0 0 1-11 12.95 48 48 0 0 1-15.34 7.71 60.63 60.63 0 0 1-17.38 2.55Z"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}
